import { useEffect, useMemo, useState } from 'react';
import { App, Form } from 'antd';
import { useNavigate } from 'react-router';
import WorkSpaceService from 'services/master/workspace';

const services = new WorkSpaceService();

const INDUSTRY_OPTIONS = [
  { label: 'Thực phẩm', value: 'Thực phẩm' },
  { label: 'Mỹ phẩm', value: 'Mỹ phẩm' },
  { label: 'Thời trang', value: 'Thời trang' },
  { label: 'Đồ gia dụng', value: 'Đồ gia dụng' },
  { label: 'Mẹ và bé', value: 'Mẹ và bé' },
  { label: 'Khác', value: 'Khác' },
];

const useComponent = ({ w_id }) => {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [workspace, setWorkspace] = useState(null);
  const [result, setResult] = useState(null);
  const [draftValues, setDraftValues] = useState(null);

  const loadWorkspace = async () => {
    if (!w_id) return;
    setLoading(true);
    try {
      const data = await services.detail({ w_id });
      setWorkspace(data?.workspace || null);

      const defaults = {
        shop_name: data?.workspace?.web_site?.title || '',
        industry: 'Thực phẩm',
        description: data?.workspace?.web_site?.description || '',
        logo_image: data?.workspace?.web_site?.image || null,
        product_images: [],
      };

      setDraftValues(defaults);
      form.setFieldsValue(defaults);
    } catch (e) {
      message.error(e?.message || 'Không thể tải thông tin shop');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadWorkspace();
  }, [w_id]);

  const isDemo = useMemo(() => {
    return !!(workspace?.is_demo || workspace?.shop_type === 'demo');
  }, [workspace]);

  const goBack = () => {
    navigate(`/workspace/${w_id}`);
  };

  const nextStep = async () => {
    if (step === 0) {
      try {
        await form.validateFields(['shop_name', 'industry']);
      } catch {
        return;
      }
    }
    setStep((prev) => Math.min(prev + 1, 2));
  };

  const prevStep = () => {
    setStep((prev) => Math.max(prev - 1, 0));
  };

  const onValuesChange = (_, allValues) => {
    setDraftValues(allValues || {});
  };

  const submit = async () => {
    try {
      await form.validateFields(['shop_name', 'industry']);
      const values = form.getFieldsValue(true);
      setSubmitting(true);
      const payload = {
        w_id,
        shop_name: values.shop_name,
        industry: values.industry || 'Thực phẩm',
        description: values.description || '',
        logo_image: values.logo_image || null,
        product_images: values.product_images || [],
      };

      const data = await services.setupDemoWebsite(payload);
      setResult(data || null);
      setStep(3);
      message.success('Thiết lập website demo thành công');
    } catch (e) {
      if (e?.errorFields) return;
      message.error(e?.message || 'Thiết lập website demo thất bại');
    } finally {
      setSubmitting(false);
    }
  };

  const openWebsite = () => {
    const url = workspace?.web_site?.url;
    if (!url) return;
    window.open(`https://${url}.sipro.store`, '_blank');
  };

  return {
    form,
    draftValues,
    step,
    loading,
    submitting,
    workspace,
    result,
    isDemo,
    industryOptions: INDUSTRY_OPTIONS,
    nextStep,
    prevStep,
    onValuesChange,
    submit,
    goBack,
    openWebsite,
  };
};

export default useComponent;
